import React from 'react';

import type { SubagentRegistry, SubagentRun } from './SubagentRegistry';

const NO_RUNS: readonly SubagentRun[] = [];
const noopUnsubscribe = () => {};

export function useSubagentRuns(registry: SubagentRegistry | undefined): readonly SubagentRun[] {
    const subscribe = React.useCallback(
        (listener: VoidFunction) => registry?.subscribe(listener) ?? noopUnsubscribe,
        [registry],
    );
    return React.useSyncExternalStore(subscribe, () => registry?.getRuns() ?? NO_RUNS);
}
